import { getCurrentAppByHostname } from '../Helpers';

const LOCAL_STORAGE_KEY = `Smartforce.${
  getCurrentAppByHostname() === 'nexus' ? 'Nexus' : 'CitizenContact'
} .RedirectDataStorage`;

export interface RedirectDataStorageProps {
  pathname: string;
  search?: string;
  redirectURL?: string;
}

export const getRedirectDataStorage = () => {
  const redirectData = localStorage.getItem(LOCAL_STORAGE_KEY);
  return redirectData ? JSON.parse(redirectData) : null;
};

export const setRedirectDataStorage = (
  redirectData: RedirectDataStorageProps
) => {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(redirectData));
};

export const clearRedirectDataStorage = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
};

export const isRedirectDataStorageSet = () => {
  return getRedirectDataStorage() !== null;
};
